import React, { useEffect, useRef, useState } from "react";
import {
	Form,
	Input,
	Button,
	Typography,
	Space,
	Alert,
	Carousel,
	Message,
} from "@arco-design/web-react";
import {
	IconLock,
	IconUser,
	IconCode,
	IconExperiment,
	IconRobot,
} from "@arco-design/web-react/icon";
import { FormInstance } from "@arco-design/web-react/es/Form";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login, clearError } from "../../store/authSlice";
import "./style.less";

const { Title, Text } = Typography;

const LoginPage: React.FC = () => {
	const formRef = useRef<FormInstance>();
	const history = useHistory();
	const dispatch = useDispatch();
	const { loading, error } = useSelector((state: any) => state.auth);

	const [currentSlide, setCurrentSlide] = useState(0);

	const bannerData = [
		{
			icon: <IconRobot style={{ fontSize: 64, color: "#FFF" }} />,
			title: "AI 驱动的医疗数据平台",
			description: "基于先进的深度学习模型，提供智能问答、数据挖掘等AI服务",
		},
		{
			icon: <IconCode style={{ fontSize: 64, color: "#FFF" }} />,
			title: "强大的API能力",
			description:
				"提供丰富的REST API接口，支持向量搜索、知识点获取、智能问答等功能",
		},
		{
			icon: <IconExperiment style={{ fontSize: 64, color: "#FFF" }} />,
			title: "专业医疗知识库",
			description:
				"整合海量医疗政策数据、市场数据、临床信息，为医疗从业者提供精准洞察",
		},
	];

	const handleLogin = async (values: any) => {
		try {
			const result = await dispatch(
				login({
					username: values.username,
					password: values.password,
				})
			);

			if ((result as any).payload.token) {
				Message.success("登录成功");
				history.push("/");
			} else {
				// Message.error("登录失败，请检查用户名和密码");
			}
		} catch (error: any) {
			console.error("Login error:", error);
		}
	};

	const handleBannerChange = (index: number) => {
		setCurrentSlide(index);
	};

	return (
		<div className="login-container">
			{/* 左侧 Banner */}
			<div className="login-banner">
				<div className="login-banner-inner">
					<Carousel
						className="login-carousel"
						animation="slide"
						autoPlay={{ interval: 5000 }}
						indicatorPosition="bottom"
						showArrow={"always"}
						indicatorType="dot"
						onChange={handleBannerChange}
					>
						{bannerData.map((item, index) => (
							<div key={index} className="login-carousel-item">
								<div className="login-carousel-icon">{item.icon}</div>
								<Title heading={2} className="login-carousel-title">
									{item.title}
								</Title>
								<Text className="login-carousel-description">
									{item.description}
								</Text>
							</div>
						))}
					</Carousel>
				</div>
			</div>

			{/* 右侧登录表单 */}
			<div className="login-content">
				<div className="login-content-inner">
					<div className="login-form-wrapper">
						{/* Logo */}
						<div className="login-logo">
							<IconRobot
								style={{ fontSize: 40, color: "var(--accent-blue)" }}
							/>
							<Title heading={4} className="login-logo-text">
								速问开放平台
							</Title>
						</div>

						<Title heading={2} className="login-form-title">
							登录您的账户
						</Title>
						<Text className="login-form-subtitle">
							欢迎回来！请输入您的用户名和密码
						</Text>

						{error && (
							<Alert
								// message="登录失败"
								content={error}
								type="error"
								showIcon
								className="login-error-alert"
								closable
								onClose={() => dispatch(clearError())}
							/>
						)}

						<Form
							ref={formRef}
							layout="vertical"
							className="login-form"
							onSubmit={handleLogin}
						>
							<Form.Item
								field="username"
								label="用户名"
								rules={[{ required: true, message: "请输入用户名" }]}
							>
								<Input
									prefix={<IconUser />}
									placeholder="请输入用户名"
									size="large"
								/>
							</Form.Item>

							<Form.Item
								field="password"
								label="密码"
								rules={[{ required: true, message: "请输入密码" }]}
							>
								<Input.Password
									prefix={<IconLock />}
									placeholder="请输入密码"
									size="large"
								/>
							</Form.Item>

							<Space direction="vertical" className="login-form-actions">
								<Button
									type="primary"
									htmlType="submit"
									long
									size="large"
									loading={loading}
									className="login-submit-btn"
								>
									{loading ? "登录中..." : "登录"}
								</Button>
							</Space>
						</Form>

						<div className="login-invitation">
							<Text className="login-invitation-text">
								🎯 我们目前采用邀请制，如需体验产品请联系管理员
							</Text>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default LoginPage;
